import { gql } from '@apollo/client/core';

export interface AdminUser {
  uuid: string;
  email: string;
  firstName: string;
  lastName: string;
  roles: string[];
  tenant?: string;
  memberships?: Membership[];
  enabled: boolean;
}

export interface Membership {
  enabled: boolean;
  organization: string;
  roles: RoleWithName[];
}

export interface RoleWithName {
  id: string;
  name: string;
}

export interface AllAdminsResponse {
  searchUsers: any;
}

export const USER_SEARCH_QUERY = gql`
  query searchUsers(
    $searchTerm: String
    $roles: [String]
    $page: Int
    $size: Int
  ) {
    searchUsers(
      searchTerm: $searchTerm
      roles: $roles
      page: $page
      size: $size
    ) {
      uuid
      email
      firstName
      lastName
      roles
      tenant
      enabled
    }
  }
`;

export const GET_ALL_ADMINS = gql`
  query searchUsers(
    $pageNumber: Int = 0
    $pageSize: Int = 10
    $roles: [String!]!
    $search: String
  ) {
    searchUsers(
      pageNumber: $pageNumber
      pageSize: $pageSize
      roles: $roles
      search: $search
    ) {
      totalCount
      users {
        uuid
        email
        firstName
        lastName
        roles
        tenant
        enabled
        memberships {
          organization
          roles {
            id
            name
          }
          enabled
        }
      }
    }
  }
`;
